import Chart from "chart.js";

const d = Chart.defaults;
d.global.responsive = true;
d.global.defaultFontColor = "#333333";
d.global.defaultFontFamily = "Roboto,sans-serif";
d.global.defaultFontSize = 11;
d.global.legend.labels.fontSize = 13;
d.global.tooltips.mode = "index";
d.global.tooltips.intersect = false;
d.global.tooltips.titleFontSize = 13;
d.global.tooltips.bodyFontSize = 12;
d.global.tooltips.bodySpacing = 3;
d.global.tooltips.xPadding = 8;
d.global.tooltips.yPadding = 8;
d.global.tooltips.caretSize = 0;
d.global.tooltips.multiKeyBackground = "transparent";
d.global.tooltips.borderWidth = 0;
d.global.legend.labels.fontSize = 12;
d.global.legend.labels.boxWidth = 30;

Chart.Legend.prototype.afterFit = function() {
  if (this.options.position === "top") {
    this.height = this.height + 20;
  }
};

Chart.Tooltip.positioners.alwaysUpTop = (unused, position) => {
  return { x: position.x, y: 0 };
};

var DefaultColors = [
  "#3182bd",
  "#e6550d",
  "#31a354",
  "#756bb1",
  "#636363",
  "#6baed6",
  "#fd8d3c",
  "#74c476",
  "#9e9ac8",
  "#969696",
  "#9ecae1",
  "#fdae6b",
  "#a1d99b",
  "#bcbddc",
  "#bdbdbd",
  "#c6dbef",
  "#fdd0a2",
  "#c7e9c0",
  "#dadaeb",
  "#d9d9d9"
];

export { DefaultColors };
